import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaPaperPlane,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaCalculator,
  FaPhoneAlt,
  FaLightbulb
} from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would send the form data to a server
    alert('Thank you for your message! We will get back to you within 24 hours.');
    setFormData({
      fullName: '',
      email: '',
      company: '',
      message: ''
    });
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="section" style={{ paddingTop: '120px', backgroundColor: 'var(--bg-grey-light)' }}>
        <div className="container text-center">
          <FaPaperPlane style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '16px' }} />
          <h1 className="h1">Let's Build Your Engineering Team</h1>
          <p className="text-lg mb-8" style={{ maxWidth: '600px', margin: '0 auto 32px' }}>
            Share your requirements and we'll recommend the right setup for your project.
          </p>
        </div>
      </section>

      {/* Contact Form and Info */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ gap: '48px' }}>
            {/* Contact Form */}
            <div className="card" style={{ padding: '40px' }}>
              <h2 className="h3 mb-6">Send us a message</h2>
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '20px' }}>
                  <label htmlFor="fullName" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '1px solid var(--border-grey)',
                      borderRadius: 'var(--border-radius)',
                      fontSize: '16px',
                      backgroundColor: 'white'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label htmlFor="email" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Work Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '1px solid var(--border-grey)',
                      borderRadius: 'var(--border-radius)',
                      fontSize: '16px',
                      backgroundColor: 'white'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label htmlFor="company" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Company
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '1px solid var(--border-grey)',
                      borderRadius: 'var(--border-radius)',
                      fontSize: '16px',
                      backgroundColor: 'white'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label htmlFor="message" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Describe your team needs, project scope, timeline, and any specific requirements..."
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '1px solid var(--border-grey)',
                      borderRadius: 'var(--border-radius)',
                      fontSize: '16px',
                      backgroundColor: 'white',
                      resize: 'vertical',
                      fontFamily: 'inherit'
                    }}
                  />
                </div>

                <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }}>
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div>
              <div className="card" style={{ padding: '40px', marginBottom: '24px' }}>
                <h2 className="h3 mb-6">Get in touch</h2>
                <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaEnvelope style={{ color: 'var(--primary-green)' }} />
                  <div>
                    <h4 className="h4 text-green mb-2">Email</h4>
                    <p style={{ margin: 0 }}>admin@thecodeicon.com</p>
                  </div>
                </div>
                {/* <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaPhone style={{ color: 'var(--primary-green)' }} />
                  <div>
                    <h4 className="h4 text-green mb-2">Phone</h4>
                    <p style={{ margin: 0 }}>+1 (555) 123-4567</p>
                  </div>
                </div> */}
                <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaMapMarkerAlt style={{ color: 'var(--primary-green)' }} />
                  <div>
                    <h4 className="h4 text-green mb-2">Location</h4>
                    <p style={{ margin: 0 }}>Farah Heights Gulberg Block 10 FB Area. Karachi, Pakistan.</p>
                  </div>
                </div>
                <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaPaperPlane style={{ color: 'var(--primary-green)' }} />
                  <div>
                    <h4 className="h4 text-green mb-2">Response Time</h4>
                    <p style={{ margin: 0 }}>Within 24 hours</p>
                  </div>
                </div>
              </div>

              <div className="card" style={{ padding: '32px', backgroundColor: 'var(--bg-grey-light)' }}>
                <h3 className="h4 mb-4" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaLightbulb style={{ color: 'var(--primary-green)' }} />
                  Quick Actions
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <Link to="/calculator" className="btn btn-primary" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <FaCalculator /> Get Team Cost Estimate
                  </Link>
                  <Link to="/how-it-works" className="btn btn-secondary" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <FaLightbulb /> Learn How It Works
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="section section-grey">
        <div className="container text-center">
          <FaPhoneAlt style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '16px' }} />
          <h2 className="h2 mb-6">Prefer a quick discussion?</h2>
          <p className="text-lg mb-8" style={{ maxWidth: '500px', margin: '0 auto' }}>
            Schedule a 30-minute call to discuss your engineering team requirements and get personalized recommendations.
          </p>
          {/* <button className="btn btn-primary btn-lg" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <FaPhoneAlt /> Schedule a Call
          </button> */}
        </div>
      </section>
    </div>
  );
};

export default Contact;
